import api from './api';

const classService = {
  /** Lightweight id/name list for dropdowns (avoids heavy get-all-classes includes). */
  getClassNames: () => api.get("/class/get-classes-names"),

  getAllClasses: async (params = {}) => {
    const { page = 1, limit = 10, sort = 'id', order = 'DESC' } = params;
    const response = await api.get('/class/get-all-classes', {
      params: {
        page,
        limit,
        sort,
        order,
        ...params
      }
    });
    return response.data;
  },
};

export default classService;
